import Request from "./Request";

class UserApi {

  static login(data){
    return new Request("/user/login", {
      method: "POST",
      data: data,
    });
  }

  static logout(){
  	return new Request("/user/logout")
  }

  static currentUser(){
  	return new Request("/user/current_user")
  }

  static newUser(data){
  	return new Request("/user/new_user", {
  		method: "POST",
  		data: data,
  	})
  }

  static getUsers(){
    return new Request("/user/get_users")
  }


}

export default UserApi;



// WEBPACK FOOTER //
// ./src/components/utils/UserApi.js